module.exports = __webpack_public_path__ + "media/img/pages/companies/ost-en-4e6a7c6d096712e11d7a62dff694de73.webp";